import { render, staticRenderFns } from "./NotPaidOrdersCard.vue?vue&type=template&id=8b6b15ae"
import script from "./NotPaidOrdersCard.vue?vue&type=script&lang=js"
export * from "./NotPaidOrdersCard.vue?vue&type=script&lang=js"
import style0 from "./NotPaidOrdersCard.vue?vue&type=style&index=0&id=8b6b15ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports